module.exports = __webpack_public_path__ + "c66b475a71b16039811e842ce54ae759.svg";